import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { listUseCases } from '../../actions/order';
import { adminListOrders } from '../../actions/superadmin';
import { storeWithExpiration } from '../../utils/common';
import { closeDialog } from '../../actions/dialog';
import { SUPER_ADMIN } from '../../config/app_config';

import OrdersIndex from '../orders/OrdersIndex';

export class OrdersIndexContainer extends React.Component {
  static propTypes = {
    adminListOrdersAction: PropTypes.func.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    orders: PropTypes.object.isRequired,
    progress: PropTypes.number,
    listUseCasesAction: PropTypes.func.isRequired,
    selectedAccount: PropTypes.object.isRequired,
  };

  static defaultProps = {
    progress: 1,
  };

  componentWillMount = () => {
    const { adminListOrdersAction, selectedAccount, listUseCasesAction } = this.props;
    const token = storeWithExpiration.get('token');
    adminListOrdersAction(selectedAccount.id, token);
    listUseCasesAction(selectedAccount.id, token);
  };

  componentWillReceiveProps = nextProps => {
    const { adminListOrdersAction, selectedAccount, listUseCasesAction } = this.props;
    if (selectedAccount.id !== nextProps.selectedAccount.id) {
      const token = storeWithExpiration.get('token');
      adminListOrdersAction(nextProps.selectedAccount.id, token);
      listUseCasesAction(nextProps.selectedAccount.id, token);
    }
  };

  render() {
    const { progress, isSuperAdmin, orders, selectedAccount } = this.props;

    // Don't load Orders unless previously loaded or loading is complete
    const isLoaded = progress < 1 || (orders !== undefined && orders.size > 0);

    return isLoaded ? (
      <div>
        <h3>{selectedAccount.companyName} Orders
        <span className="pull-right">
          {isSuperAdmin ? (
            <Link to={`/orders/create/1/${selectedAccount.id}`} className="btn btn-primary" disabled>
              <i className="fa fa-plus" />New Order
            </Link>
          ) : null}
        </span>
        </h3>
        <br />
        <div className="row">
          <div className="col-md-12">
            <OrdersIndex
              account={selectedAccount}
              isSuperAdmin={isSuperAdmin}
              minHeight={425}
              orders={orders}
            />
          </div>
        </div>
      </div>
    ) : null;
  }
}

function mapStateToProps(state) {
  const { user, progress, superadmin } = state;
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  const selectedAccount = superadmin.get('selectedAccount');
  const orders = superadmin.get('orders');
  return {
    selectedAccount,
    isSuperAdmin,
    progress,
    orders,
  };
}

export default connect(mapStateToProps, {
  adminListOrdersAction: adminListOrders,
  closeDialogAction: closeDialog,
  listUseCasesAction: listUseCases,
})(OrdersIndexContainer);
